<template>
  <v-card :loading="loading" class="my-5">
    <v-data-table
        :headers="headers"
        :items="datas"
        :items-per-page="10"
        :search="search"
        class="elevation-10 p-4"
    >
      <template v-slot:top>
        <p class="font-italic">
          تراکنش های
          <strong class="text-info">{{ phone }}</strong>
        </p>

        <v-text-field
            v-model="search"
            label="جستجو"
            append-icon="mdi-magnify"
            dense
            class="mx-4 my-3 mt-4"
        ></v-text-field>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.token }}</td>
          <td>{{ item.description }}</td>
          <td :class="item.isIncome ? 'text-success' : 'text-danger' ">{{ item.amountString }}</td>
          <td>{{ item.timeString }}</td>
          <td>{{ item.dateString }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {Axios2} from "@/main";
import PriceInput from "@/core/plugins/TitleRibbon/pages/pickers/priceInput.vue";

export default {
  name: "transActionList",
  components: {PriceInput},
  props: ['phone'],
  data() {
    return {
      headers: [
        {text: 'کد رهگیری', value: 'token', class: 'font-size-ng'},
        {text: 'توضیحات', value: 'description', class: 'font-size-ng'},
        {text: 'مبلغ', value: 'amountString', class: 'font-size-ng'},
        {text: 'ساعت پرداخت', value: 'timeString', class: 'font-size-ng'},
        {text: 'تاریخ پرداخت', value: 'dateString', class: 'font-size-ng'},
      ],
      datas: [],
      search: '',
      loading: false
    }
  },
  methods: {
    getTransActions() {
      this.loading = true;

      Axios2.get('/admin/bazaar/transactions?phone=' + this.phone).then((response) => {
        this.datas = response.data.data.list
      }).finally(() => {
        this.loading = false;
      })
    }
  },
  created() {
    this.getTransActions();
  }
}
</script>

<style>
.font-size-ng {
  font-size: 10pt !important;
  color: #1c0152 !important;
}
</style>